var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreatBritainFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 335,
    viewBox: "0 0 512 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2152_2541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H512V335H0V0Z",
    fill: "#00336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.637 0H307.444V335H204.637V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 118.263H512V216.737H0V118.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 267.455V335H490.87L0 66.3767V0H23.2432L512 267.455Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0V66.6884L21.699 335H0V267.766L489.326 0H512Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.33 0H288.752V335H223.33V0Z",
    fill: "#E0011E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 279.686V305.395L350.029 216.737H397.003L512 279.686Z",
    fill: "#E0011E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.554 118.262H121.58L0 51.7298V26.0205L168.554 118.262Z",
    fill: "#E0011E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 0V25.4756L342.471 118.263H295.497L511.594 0H512Z",
    fill: "#E0011E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.058 216.737L0 332.273V306.564L164.084 216.737H211.058Z",
    fill: "#E0011E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 136.158V198.873H-2.95639e-05V136.158H512Z",
    fill: "#E0011E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2152_2541"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 335,
    rx: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreatBritainFlag);
export default __webpack_public_path__ + "static/media/great_britain_flag.3a680bf6c8e382dab1c472011e2eb20b.svg";
export { ForwardRef as ReactComponent };